const isGrafanaBandwidthEnabled = window.checkFeatureFlag('ff-grafana-bandwidth')

const IMAGEURL = `${process.env.PUBLIC_URL}/img/test_bandwidth_200.jpg`
const DOWNLOADSIZE = 207000

const getResults = (startTime, endTime) => {
  const duration = (endTime - startTime) / 1000

  const bitsLoaded = DOWNLOADSIZE * 8
  const speedBps = (bitsLoaded / duration).toFixed(2)
  const speedKbps = (speedBps / 1024).toFixed(2)
  const speedMbps = (speedKbps / 1024).toFixed(2)

  return speedMbps
}

const bandwidthUtils = {
  async getBandwidthSpeed() {
    if (!isGrafanaBandwidthEnabled) {
      return null
    }
    const MeasureConnectionSpeed = new Promise((resolve, reject) => {
      var startTime, endTime
      var download = new Image()
      startTime = new Date().getTime()

      var cacheBuster = '?nnn=' + startTime
      download.src = IMAGEURL + cacheBuster

      download.onload = function () {
        endTime = new Date().getTime()
        const result = getResults(startTime, endTime)
        resolve(result)
      }

      download.onerror = function () {
        reject(null)
      }
    })

    const speed = await MeasureConnectionSpeed
    return speed
  },
}

export default bandwidthUtils
